import { render, staticRenderFns } from "./resumo-pendencias-justificativas.vue?vue&type=template&id=7b47c3b7&scoped=true&"
import script from "./resumo-pendencias-justificativas.vue?vue&type=script&lang=js&"
export * from "./resumo-pendencias-justificativas.vue?vue&type=script&lang=js&"
import style0 from "./resumo-pendencias-justificativas.vue?vue&type=style&index=0&id=7b47c3b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47c3b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VChip,VIcon})
